import { render } from "./LoadingElement.vue?vue&type=template&id=01010bd4&scoped=true"
import script from "./LoadingElement.vue?vue&type=script&lang=js"
export * from "./LoadingElement.vue?vue&type=script&lang=js"

import "./LoadingElement.vue?vue&type=style&index=0&id=01010bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01010bd4"]])

export default __exports__